export default {
    // C
    createDomain: 'Create domain',

    // R
    removeDomain: 'Remove domain',
}
